const USERS_PREFIX = 'users';
const INTEGRATION_SETTINGS = 'integration-settings';
const BASE_SETTINGS = 'base-settings';
const ARCHIVING = 'archiving';

// Admin Archiving Routes
function archiving(prefix: string) {

  // BATCHES Menu Settings Routes
  const BATCHES_PATH = `${prefix}/batches/`;
  
  const BATCHES_MENU = {
    ROOT: BATCHES_PATH,
    SUPERVISION_OF_BATCHES: `${BATCHES_PATH}supervision-of-batches`,
    PURGE_SETTINGS: `${BATCHES_PATH}purge-settings`,
  };

  // ARCHIVED TABLES Menu Settings Routes
  const ARCHIVED_TABLES_PATH = `${prefix}/archived-tables/`;
  
  const ARCHIVED_TABLES_MENU = {
    ROOT: ARCHIVED_TABLES_PATH,
    VALID_TRANSACTION_INQUIRY: `${ARCHIVED_TABLES_PATH}valid-transaction-inquiry`,
    VALID_TRANSACTION_INQUIRY_HISTORY: `${ARCHIVED_TABLES_PATH}valid-transaction-inquiry/history/`,
    CONSULTATION_OF_AUTHORIZATIONS: `${ARCHIVED_TABLES_PATH}consultation-of-authorizations`,
    CONSULTATION_OF_AUTHORIZATIONS_DETAILS: `${ARCHIVED_TABLES_PATH}consultation-of-authorizations/authorizations/`,
    ATM_TRANSACTION_INQUIRY: `${ARCHIVED_TABLES_PATH}atm-transaction-inquiry`,
    ATM_TRANSACTION_INQUIRY_DETAILS: `${ARCHIVED_TABLES_PATH}atm-transaction-inquiry/details/`,
  };

  return {
    ROOT: prefix,
    SETTINGS: `${prefix}/settings`,
    BATCHES_MENU,
    ARCHIVED_TABLES_MENU,
  };
}

// Admin Users Routes
function users(prefix: string) {
  return {
    ROOT: prefix,
    HOME: `${prefix}/home`,
    PROFILE: `${prefix}/profile`,
    PROFILE_OPTION_MODULE: `${prefix}/profile-option-module`,
    USERS_MANAGMENT: `${prefix}/users-management`,
    USERS_SUPERVISION: `${prefix}/users-supervision`,
    CHANGE_PASSWORD: `${prefix}/change-password`,
    PASSWORD_SETTINGS: `${prefix}/password-settings`,
    CONSULTATION_LOG_FILE: `${prefix}/consultation-log-file`,
    PURGE_LOG_FILE: `${prefix}/purge-log-file`,
    SENSIBLE_DATA_LOG: `${prefix}/sensible-data-log`,
  };
}

// Admin Integration Settings Routes
function integrationSettings(prefix: string) {
  // Base Menu Settings Routes
  const BASE_PATH = `${prefix}/base/`;

  const BASE_MENU = {
    ROOT: BASE_PATH,
    CENTER_COMMISSION_PARAMETERS: `${BASE_PATH}center-commmission-parameters`,
    BANK_COMMISSION_PARAMETERS: `${BASE_PATH}bank-commission-parameters`,
    BANK_ACCOUNT_ROUTING: `${BASE_PATH}bank-account-routing`,
    BANK_RISK_MANAGEMENT: `${BASE_PATH}bank-risk-management/`,
    SENSITIVE_DATA_PARAMETERS: `${BASE_PATH}sensitive-data-parameters`,
    BANK_CARD_NUMBER_GENERATION_METHODS: `${BASE_PATH}bank-card-number-generation-methods`,
    HPX_MODULES_MANAGEMENT: `${BASE_PATH}hpx-modules-management`,
    SETTLEMENT_PROCESSING_PARAMETER: `${BASE_PATH}settlement-processing-parameter`,
    BANK_TERMINAL_VERIFICATION_RESULT: `${BASE_PATH}bank-terminal-verification-result`,
    BANK_CARD_VERIFICATION_RESULTS: `${BASE_PATH}bank-card-verification-results`,
  };

  // ATM Menu Settings Routes
  const ATM_PATH = `${prefix}/atm/`;

  const ATM_MENU = {
    ROOT: ATM_PATH,
    STATES: `${ATM_PATH}states`,
    SCREEN: `${ATM_PATH}screen`,
    PARAMETER_VALUES: `${ATM_PATH}parameter-values`,
    OFFERED_SERVICES: `${ATM_PATH}offered-services`,
    CONFIGURED_SERVICES: `${ATM_PATH}configured-services`,
    REPLY_VALUES: `${ATM_PATH}reply-values`,
  };

  return {
    ROOT: prefix,
    BASE_MENU,
    ATM_MENU,
    CARDHOLDER: `${prefix}/card-holder`,
    MERCHANT: `${prefix}/merchant`,
    SWITCH_AND_VISA_BASELL: `${prefix}/switch-and-visa-basell`,
    VISA_BASE_II: `${prefix}/visa-base-II`,
    SWITCH: `${prefix}/switch`,
    BATCH_PROCESSING: `${prefix}/batch-processing`,
  };
}

// Admin Base Settings Routes
function basicSettings(prefix: string) {
  const CENTER_PATH = `${prefix}/center`;
  const PARAMETERS_PATH = `${CENTER_PATH}/settings`;
  const CENTER_MENU = {
    ROOT: `${CENTER_PATH}`,
    UPDATE: `${CENTER_PATH}/update`,
    PAYMENT_SYSTEM: `${CENTER_PATH}/payment-system`,
    DEVISE: `${CENTER_PATH}/devise`,
    MERCHANT: `${CENTER_PATH}/merchant`,
    BANK: `${CENTER_PATH}/bank`,
    CENTER_COMMISSION: `${CENTER_PATH}/center-commission`,
    TVA: `${CENTER_PATH}/tva`,
    PARAMETERS: {
      ROOT: PARAMETERS_PATH,
      COUNTRY: `${PARAMETERS_PATH}/country`,
      CITY: `${PARAMETERS_PATH}/city`,
      COMPANY_TYPE: `${PARAMETERS_PATH}/company-type`,
      DOCUMENT_TYPE: `${PARAMETERS_PATH}/document-type`,
      CARD_OBJECTION_REASON: `${PARAMETERS_PATH}/card-objection-reason`,
      BIN_OBJECTION_REASON: `${PARAMETERS_PATH}/bin-objection-reason`,
      CORRESPONDANCE_TYPE: `${PARAMETERS_PATH}/correspondance-type`,
      ADDRESS_TYPE: `${PARAMETERS_PATH}/address-type`,
      VACANCY_TYPE: `${PARAMETERS_PATH}/vacancy-type`,
      TITLE: `${PARAMETERS_PATH}/title`,
      PROFESSIONAL_POSITION: `${PARAMETERS_PATH}/professional-positions`,
      DELIVERY_OPERATOR: `${PARAMETERS_PATH}/delivery-operator`,
    },
  };

  function bankRoutes(prefix: string) {
    const BANK_PATH = `${prefix}/bank`;
    const DEVISE_PATH = `${BANK_PATH}/devise`;
    const MARCHANTS_PATH = `${BANK_PATH}/marchants`;
    const COMMISION_PATH = `${BANK_PATH}/bank-commision`;
    const RISK_MANAGEMENT_PATH = `${BANK_PATH}/risk-management`;

    return {
      BANK: {
        ROOT: BANK_PATH,
        UPDATE: `${BANK_PATH}/update`,
        PAYMENT_SYSTEM: `${BANK_PATH}/payment-system`,
        TRANSACTION_TYPE: `${BANK_PATH}/transaction-type`,
        CALENDAR: `${BANK_PATH}/calendar`,
        DEVISE: {
          ROOT: DEVISE_PATH,
          DIVISE_DEFINITION: `${DEVISE_PATH}/definition`,
          UPDATE_CONVERSION_TAUX: `${DEVISE_PATH}/update-conversion-taux`,
          CONVERSION_TAUX_CONSULTATION: `${DEVISE_PATH}/conversion-taux-consultation`,
        },
        MARCHANTS: {
          ROOT: MARCHANTS_PATH,
          MARCHANT_CATEGORY: `${MARCHANTS_PATH}/category`,
          MARCHANT_GROUP: `${MARCHANTS_PATH}/group`,
          MARCHANT_CATEGORY_GROUP: `${MARCHANTS_PATH}/category-group`,
        },
        PROMOTOR: `${BANK_PATH}/promotor`,
        BANK_COMMISSION: {
          ROOT: `${COMMISION_PATH}`,
          COMMISSION: `${COMMISION_PATH}/commision`,
          INTERCHANGE: `${COMMISION_PATH}/interchange`,
        },
        CONTRAT_TYPE: `${BANK_PATH}/contrat-type`,
        SOLVIBILITY_LEVEL: `${BANK_PATH}/solvability-level`,
        BIEN_DESC: `${BANK_PATH}/bien-desc`,
        INCOME_TYPE: `${BANK_PATH}/income-type`,
        CREANCIER_TYPE: `${BANK_PATH}/creancier-type`,
        ASSURANCE_TYPE: `${BANK_PATH}/assurance-type`,
        IMPRESSION_SETTINGS: `${BANK_PATH}/impression-settings`,
        IMPRESSION_SETTINGS_FIELDS: `${BANK_PATH}/impression-champs-settings`,
        RISK_MANAGEMENT: {
          ROOT: RISK_MANAGEMENT_PATH,
          EMETTRICE: `${RISK_MANAGEMENT_PATH}/emettrice`,
          ACQUIERER: `${RISK_MANAGEMENT_PATH}/acquierer`,
        },
      },
    };
  }

  return {
    ROOT: prefix,
    CENTER_PATH,
    CENTER_MENU,
    ...bankRoutes(prefix),
    AGENCE: `${prefix}/agence`,
  };
}

export function admin(prefix: string) {
  return {
    ROOT: prefix,

    // Archiving
    ARCHIVING: {
      ...archiving(`${prefix}/${ARCHIVING}`),
    },

    // Users
    USERS: {
      ...users(`${prefix}/${USERS_PREFIX}`),
    },

    // Base Settings
    BASE_SETTINGS: {
      ...basicSettings(`${prefix}/${BASE_SETTINGS}`),
    },

    // Integration settings
    INTEGRATION_SETTINGS: {
      ...integrationSettings(`${prefix}/${INTEGRATION_SETTINGS}`),
    },
  };
}
